module.exports = __webpack_public_path__ + "media/images/icon_arrow_sp_down-7cc413ca2269bffb1c4be23bfef97f29.png";